import React, { createContext, useCallback, useContext, useMemo, useState, useEffect } from "react";
import dataService from '../services/Data'
import PropTypes from 'prop-types'

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(window.localStorage.getItem('loggedNoteAppUser') ? JSON.parse(window.localStorage.getItem('loggedNoteAppUser')) : null) //useLocalStorage('loggedNoteAppUser', null)
    const [lastActivity, setLastActivity] = useState(Date.now());


    // Detectar actividad del usuario
    useEffect(() => {
        const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

        const updateActivity = () => {
            setLastActivity(Date.now());
        };

        events.forEach(event => window.addEventListener(event, updateActivity));

        return () => {
            events.forEach(event => window.removeEventListener(event, updateActivity));
        };
    }, []);

    const login = useCallback((user) => {
        setUser(user)
        dataService.setToken(user.data.token)
        window.localStorage.setItem('loggedNoteAppUser', JSON.stringify(user))
    }, [])

    const logout = useCallback(() => {
        setUser(null)
        dataService.setToken(null)
        window.localStorage.removeItem('loggedNoteAppUser')
    }, [])

    const isSessionActive = () => {
        if (!user?.data?.token) return false;

        const tokenExpired = dataService.isTokenExpired(user.data.token);
        if (!tokenExpired) return true; // Token aún válido → todo bien

        // Token expirado, pero ¿hubo actividad reciente?
        const inactivityTime = Date.now() - lastActivity;
        const gracePeriod = 30 * 60 * 1000; // 30 minutos de gracia después de expirar

        return inactivityTime < gracePeriod;
    };

    const value = useMemo(() => ({
        login,
        logout,
        user,
        isSessionActive
    }), [login, logout, user])

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}

export function useAuth() {
    return useContext(AuthContext)
}

AuthContext.propTypes = {
    children: PropTypes.object
};